import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { StorageService } from "@core/services/storage/storage.service";
import { Http, HttpOptions } from "@capacitor-community/http";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { CloudFolder } from "@shared/models/file-types";
import { environment } from "@env";
import { LoadingService } from "../services/loading/loading.service";
import { TranslateService } from "@ngx-translate/core";
import { Capacitor } from "@capacitor/core";
import { Router } from "@angular/router";
import { SharedService } from "../services/shared/shared.service";

@Injectable()
export class Box {
  accessToken: any;
  folderHistory: CloudFolder[] = [
    {
      name: "Home",
      id: "0",
    },
  ];
  clientID = environment.boxClientID;
  clientSecret = environment.boxClientSecret;
  // clientID = 'pcv9pwr2a3mqm03ho0ofhhczjfhzablu';
  // clientSecret = 'hFjRO02Hq1eOaWLZLGmWkAkSWc5x3HKI';
  // developerToken = 'JAfcZpXhu6HMD8OgWHWiFZ99T4MJCmiX';
  developerToken = null;
  redirectURI = environment.redirectBaseUrl + "box";
  url: any;
  box: any;

  endpoint = "http://localhost:3000/users";

  constructor(
    private httpClient: HttpClient,
    private loadingSvc: LoadingService,
    private storageSvc: StorageService,
    private translateService: TranslateService,
    private router: Router,
    private sharedService: SharedService,
    private iab: InAppBrowser
  ) {
    this.url =
      "https://account.box.com/api/oauth2/authorize?client_id=" +
      this.clientID +
      "&redirect_uri=" +
      this.redirectURI +
      "&response_type=code";
  }

  setAccessToken(token) {
    this.accessToken = token;
  }

  getRootFolder() {}

  getFolders(
    folderId = "0",
    name: string = this.translateService.instant("ALL_FILES")
  ): Promise<any> {
    const history = this.folderHistory;

    const i = history.findIndex((e) => e.id === folderId);

    if (i >= 0) {
      this.folderHistory = history.slice(0, i);
    }

    this.folderHistory.push({
      id: folderId,
      name,
    });

    // if (!this.folderHistory.includes(folderId)) {
    //   this.folderHistory.push(folderId);
    // }
    const httpOptions: HttpOptions = {
      url: "https://api.box.com/2.0/folders/" + folderId + "/items",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.accessToken,
      },
    };

    // let folderPath;

    // if (typeof folderId == 'undefined' || !folderId) {
    //   folderPath = {
    //     path: '',
    //   };
    // } else {
    //   folderPath = {
    //     path,
    //   };

    // }

    return Http.get(httpOptions);
  }

  downloadFile(fileID) {
    //https://api.box.com/2.0/files/:file_id/content
    // const httpOptions: HttpOptions = {
    //   url: `https://api.box.com/2.0/files/${fileID}/content`,
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: 'Bearer ' + this.accessToken,
    //   },
    // };

    // return Http.get(httpOptions)
    //   .then((response) => response.data)
    //   .then((stream) => new Response(stream))
    //   .then((response) => response.blob());

    return new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", `https://api.box.com/2.0/files/${fileID}/content`, true);
      xhr.setRequestHeader("Authorization", "Bearer " + this.accessToken);
      // xhr.setRequestHeader( 'Dropbox-API-Arg', JSON.stringify({ path:  filePath }));
      xhr.responseType = "arraybuffer";
      xhr.onload = async () => {
        resolve(xhr.response);
      };
      xhr.send();
    });
  }

  authorize() {
    return new Promise(async (resolve, reject) => {
      const browserType = Capacitor.isNativePlatform() ? "_system" : "_self";
      const browser = this.iab.create(this.url, browserType, "location=no");

      const listener = browser.on("loadstart").subscribe(async (res) => {
        //Ignore the dropbox authorize screen
        if (res.url.indexOf("oauth2/authorize") > -1) {
          return;
        }
        //Check the redirect uri
        if (res.url.indexOf(this.redirectURI) > -1) {
          const token = res.url.split("=")[1].split("&")[0];

          listener.unsubscribe();
          browser.close();
          await this.loadingSvc.present("Please wait...");
          await this.fetchToken(token);
          await this.loadingSvc.dismiss();
          resolve(true);
        } else {
          reject(this.translateService.instant("COULD_NOT_AUTHENTICATE"));
        }
      });
    });
  }

  saveToken(token) {
    const cstamp = this.currentTimestamp();
    token.expires = Number(token.expires_in ? token.expires_in : "0") + cstamp;
    this.storageSvc.setJson("boxtoken", token);
  }

  fetchToken(code): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      };

      const body = {
        code,
        grant_type: "authorization_code",
        client_id: this.clientID,
        client_secret: this.clientSecret,
      };

      this.httpClient
        .post(
          "https://api.box.com/oauth2/token",
          new HttpParams({
            fromObject: body,
          }),
          httpOptions
        )
        .subscribe(
          (res: any) => {
            this.saveToken(res);
            resolve(true);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        );
    });
  }
  refreshToken(token): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      };

      const body = {
        refresh_token: token,
        grant_type: "refresh_token",
        client_id: this.clientID,
        client_secret: this.clientSecret,
      };

      this.httpClient
        .post(
          "https://api.box.com/oauth2/token",
          new HttpParams({
            fromObject: body,
          }),
          httpOptions
        )
        .subscribe(
          (res: any) => {
            this.saveToken(res);
            resolve(res.access_token);
          },
          (error) => {
            console.error(error);
            resolve(null);
          }
        );
    });
  }

  async getToken() {
    const cstamp = this.currentTimestamp();
    const obj = await this.storageSvc.getJson("boxtoken");
    if (obj) {
      if (obj.expires > cstamp) {
        return obj.access_token;
      } else {
        const token = await this.refreshToken(obj.refresh_token);
        return token;
      }
    }

    return null;
  }
  boxBrowserLoginHandler(url: string) {
    const token = url.split("?code=")[1];
    if (token && token.length > 0) {
      this.fetchToken(token)
        .then((success) => {
          if (success) {
            return this.router.navigate(["/app/add-files/box-list"]);
          }
        })
        .catch(async () => {
          this.sharedService.showErrorToast();
        });
      return this.router.navigate(["/app/add-files"]);
    }
  }

  private currentTimestamp(): number {
    return Math.floor(new Date().getTime() / 1000);
  }
}
